if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('custom-ajax-cart')
          || document.querySelector('cart-notification')
          || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButtonDefaultText = this.submitButtonText ? this.submitButtonText.textContent : '';

        if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.classList.add('is-custom-cart-adding');
        if (this.submitButtonText) this.submitButtonText.textContent = 'Adding...';
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const productSection = this.closest('[data-hanso-product-main]');
        if (productSection && productSection.dataset.earlyBird === 'true') {
          const baseProperties = {};
          const additionalItems = {};

          formData.forEach((value, name) => {
            const baseProperty = name.match(/^properties\[([^\]]+)\]$/);
            const itemValue = name.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
            const itemProperty = name.match(/^items\[(\d+)\]\[properties\]\[([^\]]+)\]$/);

            if (baseProperty) {
              baseProperties[baseProperty[1]] = value;
            } else if (itemValue) {
              additionalItems[itemValue[1]] = additionalItems[itemValue[1]] || { properties: {} };
              additionalItems[itemValue[1]][itemValue[2]] = Number(value);
            } else if (itemProperty) {
              additionalItems[itemProperty[1]] = additionalItems[itemProperty[1]] || { properties: {} };
              additionalItems[itemProperty[1]].properties[itemProperty[2]] = value;
            }
          });

          const accessoryDiscount = Number(productSection.dataset.earlyBirdAccessoryDiscount) || 0;
          const phase = productSection.dataset.earlyBirdPhase || '';
          const items = [{
            id: Number(formData.get('id')),
            quantity: Number(formData.get('quantity')) || 1,
            properties: baseProperties,
          }];

          Object.keys(additionalItems)
            .sort((a, b) => Number(a) - Number(b))
            .forEach((key) => {
              const item = additionalItems[key];
              if (!item.id || !item.quantity) return;
              if (accessoryDiscount > 0 && !item.properties._early_bird_gift) {
                item.properties._early_bird_accessory = phase;
              }
              items.push(item);
            });

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify({
            items,
            sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : undefined,
            sections_url: window.location.pathname,
          });
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.classList.remove('is-custom-cart-adding');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if (this.submitButtonText) {
              this.submitButtonText.textContent = this.submitButtonDefaultText || window.variantStrings.addToCart;
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
